import React from "react";
import Link from "gatsby-link";
import { Info, Download } from "react-feather";
import DownloadLink from "../components/DownloadLink";
import Content from "../components/layout/Content";
import EmailCaptureForm from "../components/Form";

const resources = ({ transition }) => (
  <div className="Shell" style={transition && transition.style}>
    <Content header>
      <div className="container">
        <article className="Article mb4">
          <header className="Article__header">
            <h2>Ladda ner Pyramidanalys</h2>
          </header>
          <p>
            Med Arbetsförmedlingens enkla steg-för-steg analys kan du kartlägga
            vilka kompetenser du behöver till din organisation.
          </p>
          <p>
            <DownloadLink
              content="/assets/pyramidanalys.pdf"
              icon={<Download />}
            >
              Ladda ner Pyramidanalys (PDF)
            </DownloadLink>
          </p>
          <div className="Article__divider">
            <span className="Article__divider__text">Eller</span>
          </div>

          <EmailCaptureForm />

          <footer className="Article__footer">
            <p>
              <Link className="infoLink" to="/about/">
                <Info className="infoLink__icon" />Läs mer om varför vi tagit
                fram det här spelet och pyramidanalysen.
              </Link>
            </p>
          </footer>
        </article>
      </div>
    </Content>
  </div>
);

export default resources;



// WEBPACK FOOTER //
// ./src/pages/resources.js